<template>
  <div class="ts-steps">
    <div class="dots">
      <div v-for="(step, i) in steps" :key="i" class="wrapper">
        <div v-if="i" class="separator"></div>
        <div class="dot" :class="{ selected: current >= i }">
          <ts-icon v-if="current > i" icon="check" size="x-small" color="#6d7587"></ts-icon>
          <span v-else class="step-number">{{ i + 1 }}</span>
        </div>
        <div class="name" :class="{ current: current === i }">{{ step.name }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ts-steps {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.dots {
  display: flex;

  .wrapper {
    display: flex;
    align-items: center;
  }

  .dot {
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.8) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

    &.selected {
      background: #ebecf0;
      background-image: linear-gradient(-42deg, #000000 0%, #ffffff 100%);
      background: #99ffd1;
      border: 2px solid rgba(255, 255, 255, 0.32);
      box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
    }
  }

  .step-number {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #6d7587;
  }

  .separator {
    width: 30px;
    height: 5px;
    margin: 0 4px;

    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 1px solid rgba(255, 255, 255, 0.32);
    box-shadow: inset 2px 2px 4px 0 #cacaca, inset -2px -2px 4px 0 #fafbff;
    border-radius: 5px;
  }
}

.name {
  font-family: Roboto;
  font-size: 14px;
  text-align: center;
  color: #9aa5b7;

  margin-left: 12px;

  &.current {
    color: black;
  }
}
</style>

<script>
export default {
  name: 'TsLargeSteps',
  props: {
    current: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentName() {
      return this.steps[this.current]?.name;
    }
  }
};
</script>
